import { Button, Input, Tag } from "antd";
import React from "react";
import { useDeviceLogConnection } from "./model";
import "./SelectDevice.scss";
import { useSelector } from "react-redux";
import { loggerModel } from "../../entities/Logger";
const SelectDeviceLog = () => {
  const {
    deviceId,
    loading,
    setDeviceId,
    connectToDevice,
    deleteLogs,
    closeLogWebSocket,
  } = useDeviceLogConnection();
  const logger = useSelector(loggerModel.selectLoggerState);
  const isConnected = loggerModel.selectLoggerIsConnected(logger);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDeviceId(e.target.value);
  };
  return (
    <div className="select-device">
      <div style={{ display: "flex", alignItems: "center" }}>
        <div className="select-device__label">ID котича</div>
        <Input
          className="select-device__select"
          value={deviceId}
          onChange={onChange}
        />
        {isConnected ? (
          <Button
            className="select-device__disconnect_button"
            type="primary"
            loading={loading}
            onClick={() => {
              closeLogWebSocket();
            }}
          >
            Отключиться
          </Button>
        ) : (
          <Button
            className="select-device__connect_button"
            type="primary"
            loading={loading}
            onClick={() => {
              connectToDevice();
            }}
          >
            Подключиться
          </Button>
        )}
        <Button
          className="select-device__button"
          danger
          type="primary"
          loading={loading}
          onClick={deleteLogs}
        >
          Удалить лог
        </Button>
      </div>

      <div className="select-device__state">
        {`Статус: `}
        <Tag
          style={{
            marginLeft: 4,
          }}
          color={isConnected ? "green" : "red"}
        >
          {isConnected ? "Подключено" : "Нет соединения"}
        </Tag>
      </div>
    </div>
  );
};

export default SelectDeviceLog;
